(function ($, root, undefined) {
	
	$(function () {
		
		
		//Flexslider
		$(window).load(function() {
			$('.slider').flexslider({
			    controlsContainer: $(".custom-controls-container"),
			    randomize: true
			});
		});
		
		
		//Mobile Menu
		var $asterisk = document.getElementById('asterisk');
		var $menu = document.getElementById('menu');
		var $togglebutton = document.getElementById('toggle');
		var $item1 = document.getElementById('menu-item-25');
		var $item2 = document.getElementById('menu-item-26');
		var $item3 = document.getElementById('menu-item-35');
		var $item4 = document.getElementById('menu-item-34');
		var $toggle = document.getElementById('toggle');
		
		$toggle.addEventListener('click', function() {
		    var isOpen = $item1.classList.contains('slide-in');
		
		    $menu.setAttribute('class', isOpen ? '' : 'slide-in');
		    $asterisk.setAttribute('class', isOpen ? 'spin-out' : 'spin-in');
		    $togglebutton.setAttribute('class', isOpen ? 'dark' : 'light');
		    $item1.className += (isOpen ? ' slide-out' : ' slide-in');
		    $item1.classList.remove(isOpen ? 'slide-in' : 'slide-out');
		    setTimeout(function(){$item2.className += (isOpen ? ' slide-out' : ' slide-in');},100);
		    setTimeout(function(){$item2.classList.remove(isOpen ? 'slide-in' : 'slide-out');},100);
		    setTimeout(function(){$item3.className += (isOpen ? ' slide-out' : ' slide-in');},200);
		    setTimeout(function(){$item3.classList.remove(isOpen ? 'slide-in' : 'slide-out');},200);
		    setTimeout(function(){$item4.className += (isOpen ? ' slide-out' : ' slide-in');},300);
		    setTimeout(function(){$item4.classList.remove(isOpen ? 'slide-in' : 'slide-out');},300);
		    setTimeout(function(){$menu.setAttribute('class', isOpen ? 'slide-out' : '');},400);
		});
		
		
		//Google Maps JS
		
			/*
		*  new_map
		*
		*  This function will render a Google Map onto the selected jQuery element
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$el (jQuery element)
		*  @return	n/a
		*/	
				
				function new_map( $el ) {
			
			// var
			var $markers = $el.find('.marker');
			
			
			// vars
			var args = {
				zoom		: 16,
				center		: new google.maps.LatLng(0, 0),
				mapTypeId	: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false
			};
			
			
			// create map	        	
			var map = new google.maps.Map( $el[0], args);
			
			
			// add a markers reference
			map.markers = [];
			
			
			// add markers
			$markers.each(function(){
				
		    	add_marker( $(this), map );
				
			});
			
			
			// center map
			center_map( map );
			
			
			// return
			return map;
			
		}
		
		/*
		*  add_marker
		*
		*  This function will add a marker to the selected Google Map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	$marker (jQuery element)
		*  @param	map (Google Map object)
		*  @return	n/a
		*/
		
		function add_marker( $marker, map ) {
		
			// var
			var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
		
			// create marker
			var marker = new google.maps.Marker({
				position	: latlng,
				map			: map
			});
		
			// add to array
			map.markers.push( marker );
		
			// if marker contains HTML, add it to an infoWindow
			if( $marker.html() )
			{
				// create info window
				var infowindow = new google.maps.InfoWindow({
					content		: $marker.html()
				});
		
				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', function() {
		
					infowindow.open( map, marker );
		
				});
			}
		
		}
		
		/*
		*  center_map
		*
		*  This function will center the map, showing all markers attached to this map
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	4.3.0
		*
		*  @param	map (Google Map object)
		*  @return	n/a
		*/
		
		function center_map( map ) {
		
			// vars
			var bounds = new google.maps.LatLngBounds();
		
			// loop through all markers and create bounds
			$.each( map.markers, function( i, marker ){
		
				var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
		
				bounds.extend( latlng );
		
			});
		
			// only 1 marker?
			if( map.markers.length == 1 )
			{
				// set center of map
			    map.setCenter( bounds.getCenter() );
			    map.setZoom( 16 );
			}
			else
			{
				// fit to bounds
				map.fitBounds( bounds );
			}
		
		}
		
		/*
		*  document ready
		*
		*  This function will render each map when the document is ready (page has loaded)
		*
		*  @type	function
		*  @date	8/11/2013
		*  @since	5.0.0
		*
		*  @param	n/a
		*  @return	n/a
		*/
		// global var
		var map = null;
		
		$(document).ready(function(){
		
			$('.acf-map').each(function(){
		
				// create map
				map = new_map( $(this) );
		
			});
		
		});
		
		
		
		
		
		
		
	});
	
})(jQuery, this);


